import './_minimap.scss';
import {useEffect, useRef, useState} from "react";
import puzzles from "../../utils/puzzles";
import VStore from "../../store";

const FLOORS = [
    {id: 'floor_1', name: 'Floor 1'},
    {id: 'floor_2', name: 'Floor 2'}
];

const MiniMap = () => {
    const iframeRef = useRef(null);
    const {currentFloor} = VStore();

    const [isShownFloor, setIsShownFloor] = useState(false);

    useEffect(() => {
        window.addEventListener('message', function (e) {
            if (e.data === 'map_loaded') {
                //@ts-ignore
                puzzles.setMapProcedures(iframeRef.current.contentWindow.v3d.puzzles.procedures);
            } else if (e.data.type === 'update_360') {
                puzzles.procedures?.moveTo(e.data.target);
            }
        })
    }, []);

    useEffect(() => {
        if (currentFloor) {
           puzzles.mapProcedures?.updateActiveFloor(currentFloor);
        }
    }, [currentFloor]);

    return (
        <div className={"minimap-wrapper" + (currentFloor ? ' show': '')}>
            <div>
                <iframe id='minimap' src="./assets/3dmodel/map_2D" title='Mini Map' ref={iframeRef}></iframe>
                <div className='floor-container'
                        onMouseLeave={() => setIsShownFloor(false)}
                >
                    <button className='floor-btn'
                            onMouseEnter={() => setIsShownFloor(true)}
                    >
                        <img src="./assets/images/layer.svg" alt="Floor"/>
                    </button>
                    <ul className={'floor-list' + (isShownFloor ? ' show': '')}>
                        {
                            FLOORS.map(floor => (
                                <li key={floor.id}
                                    onClick={() => {
                                        puzzles.procedures?.setFloor(floor.id);
                                    }}
                                    className={currentFloor === floor.id ? 'active' : ''}
                                >{floor.name}</li>
                            ))
                        }
                    </ul>
                </div>
                <div className='floor-name'>
                    <span>
                        {FLOORS.find(floor => floor.id === currentFloor)?.name || 'Floor 1'}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default MiniMap;
